import React from "react";
import { ProviderIcon } from "../../../shared/ProviderIcon";
import { PROVIDER_ORDER } from "../providerMap";
import { humanize } from "../strategyShape";
import { SectionLabel } from "./shared";

export default function PromptDetailsCard({ strategy, embedded = false }) {
	const body = (
		<>
			<p className="monitoring__analysis-strategy-prompt-text mb-0">
					{strategy.prompt.text}
				</p>
				<dl className="monitoring__analysis-strategy-meta mb-0">
					<div>
						<dt>Intent</dt>
						<dd>{humanize(strategy.prompt.intent)}</dd>
					</div>
					<div>
						<dt>Entity Type</dt>
						<dd>{humanize(strategy.prompt.entity_type)}</dd>
					</div>
					<div>
						<dt>Industry</dt>
						<dd>{humanize(strategy.prompt.industry)}</dd>
					</div>
					{Object.values(strategy.prompt.geo ?? {}).filter(Boolean).length > 0 && (
						<div>
							<dt>Location</dt>
							<dd>{Object.values(strategy.prompt.geo).filter(Boolean).join(", ")}</dd>
						</div>
					)}
					<div>
						<dt>Model Providers</dt>
						<dd className="monitoring__analysis-strategy-meta-icons">
							{PROVIDER_ORDER.map((p) => (
								<ProviderIcon key={p} provider={p} size={14} />
							))}
						</dd>
					</div>
					<div>
						<dt>Analyzed On</dt>
						<dd>{new Date(strategy.created_at).toLocaleString()}</dd>
					</div>
				</dl>
		</>
	);

	if (embedded) return body;

	return (
		<div className="monitoring__analysis-strategy-card monitoring__analysis-strategy-row-card monitoring__analysis-strategy-context-card">
			<div className="monitoring__analysis-strategy-card-head">
				<SectionLabel>Prompt Details</SectionLabel>
			</div>
			<div className="monitoring__analysis-strategy-card-body">{body}</div>
		</div>
	);
}
